import { AddTeamRequest, TeamResponse, TeamsResponse } from '../models/api';
import { deleteData, getData, postData, putData } from './api';
import { ApiEmptyResponse, ResponseData } from './models';

export const list = async (): Promise<ResponseData<TeamsResponse>> =>
  getData(`api/teams`);

export const get = async (
  teamReference: string
): Promise<ResponseData<TeamResponse>> =>
  getData<TeamResponse>(`api/teams/${teamReference}`);

export const add = async (
  model: AddTeamRequest
): Promise<ResponseData<TeamResponse>> =>
  postData<TeamResponse>('api/teams', model);
export const update = async (
  teamReference: string,
  model: AddTeamRequest
): Promise<ResponseData<TeamResponse>> =>
  putData<TeamResponse>(`api/teams/${teamReference}`, model);
export const remove = async (
  teamReference: string
): Promise<ResponseData<ApiEmptyResponse>> =>
  deleteData(`api/teams/${teamReference}`);
